import React from "react";
import "./footer.scss";

const Footer = () => {
  return (
    <div className="loginfooter">
      <div className="custom-container">
        <div className="innerloginfooter">
          <img src="/logo.svg" alt="logoimg" className="logoimg" />
          <p className="footerpara">©2026 XEN. All rights reserved</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
